<style lang="less" src="./headers.less" scoped></style>
<template>
  <div class="headers">
    <img :src="heard_left" class="headers-icon-left" @click="goTo" />
    <div class="headers-title">
      {{ title }}
    </div>
    <div class="headers-border"></div>
  </div>
</template>
<script>
import heard_left from "@roots/pLibrary/img/common/heard_left.png";
export default {
  data() {
    return {
      title: "",
      heard_left
    };
  },
  props: {
    goBack: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    const that = this;
    that.$route.meta.title &&
      (function() {
        that.title = that.$route.meta.title;
      })();
  },
  methods: {
    goTo() {
      const that = this;
      if (that.goBack && that.goBack.name) {
        that.$router.push({
          name: that.goBack.name
        });
      } else {
        that.$router.go(-1);
      }
    }
  }
};
</script>
